import { apiClient } from '@/lib/api/client';
import type {
  MerchantDevicesHealthQueryParams,
  MerchantDevicesHealthResponse,
  MerchantDisplaySelfTestResponse,
  MerchantReceiptsQueryParams,
  MerchantReceiptsResponse,
  MerchantSummaryQueryParams,
  MerchantSummaryResponse,
} from './types';

export async function getMerchantSummary(
  params: MerchantSummaryQueryParams,
): Promise<MerchantSummaryResponse> {
  const { data } = await apiClient.get<MerchantSummaryResponse>('/merchant/summary', { params });
  return data;
}

export async function getMerchantReceipts(
  params: MerchantReceiptsQueryParams,
): Promise<MerchantReceiptsResponse> {
  const { data } = await apiClient.get<MerchantReceiptsResponse>('/merchant/receipts', { params });
  return data;
}

export async function getMerchantDevicesHealth(
  params: MerchantDevicesHealthQueryParams,
): Promise<MerchantDevicesHealthResponse> {
  const { data } = await apiClient.get<MerchantDevicesHealthResponse>('/merchant/devices/health', {
    params,
  });
  return data;
}

export async function postMerchantDisplaySelfTest(
  deviceId: string,
): Promise<MerchantDisplaySelfTestResponse> {
  const { data } = await apiClient.post<MerchantDisplaySelfTestResponse>(
    `/merchant/devices/${deviceId}/test-display`,
  );
  return data;
}
